import CampaignGeneralInformationForm from './CampaignGeneralInformationForm'

export default CampaignGeneralInformationForm
